import React from "react";
import { useNavigate } from "react-router-dom";
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';
import "./Freizeit.css";

function Freizeit() {
  const navigate = useNavigate();

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title">Freizeit</h1>
        <div className="button-container">
          <button className="button_boring_red" onClick={() => navigate("/freizeithinzufuegen")}>
          <span className="material-symbols-outlined">add_circle</span>
            Neues Freizeitangebot hinzufügen
          </button>
          <button className="button_boring_red" onClick={() => navigate("/freizeitverwaltung")}>
          <span className="material-symbols-outlined">edit</span>
            Freizeitangebot bearbeiten
          </button>
          <button className="button_boring_red" onClick={() => navigate("/freizeitmarkieren")}>
          <span className="material-symbols-outlined">map</span>
          Freizeitangebot auf Karte markieren
          </button>
        </div>
      </div>
    </KernteamLayout>
  );
}

export default Freizeit;
